<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >
                    
                    <div class="hidden-lg hidden-md hidden-xl">    
                        <center>
                            <img src="/static/images/logo.png" class="logo-inicio">
                        </center>
                    </div>

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>Olá {{$root.user.nome}}</h3>
                    </div>
            
                    <!-- Row -->
                    <div class="row">
                        <div class="col-xs-12 col-xl-4 col-lg-6 col-md-6" v-if="$root.user.tipo != 'contratante' && data.notificacoes.itens.length > 0">
                            <h4 class="margin-bottom-10">
                                <i class="material-icons">email</i>
                                Lembretes
                            </h4>                            
                            <div v-for="(item, index) in data.notificacoes.itens">
                                <p class="page-text margin-top-5 margin-bottom-5" style="color: #555; font-size: 16px;">
                                    <b style="display: block; margin-bottom: 5px; color: #111; font-size: 18px;">
                                        {{item.titulo}}
                                    </b>
                                    <span v-html="item.texto.replace(/(?:\r\n|\r|\n)/g, '<br>')" style="display: block; line-height: 120%;"></span>
                                    <span v-if="item.confirmacao == 1" style="font-size: 12px; color: red;">
                                        <hr style="opacity: 0.5;">
                                        <i class="material-icons" style="font-size: inherit; top: 4px;">warning</i>
                                        Confirmação de leitura pendente
                                        <br>
                                        <button type="button" class="dashboard-status-button green margin-top-10" v-on:click="confirmarNotificacoes(item.cod)">
                                            <i class="material-icons">check_circle</i>
                                            Confirmar leitura
                                        </button>
                                    </span>
                                </p>
                            </div>
                            <div class="margin-bottom-20"></div>
                        </div>
                        <div class="col-xs-12" v-if="$root.user.tipo != 'contratante' && data.pedidosRascunho.length > 0">
                
                            <h4 class="margin-bottom-10">
                                <i class="material-icons">warning</i>
                                Abastecimentos com envio pendente
                            </h4>

                            <div class="table-scroll" style="overflow-x: scroll;">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 250px; width: 250px;">
                                            Cliente
                                        </th>        
                                        <th style="min-width: 200px; ">
                                            Piloto
                                        </th>    
                                        <th style="min-width: 130px; width: 130px;">
                                            Combustível
                                        </th> 
                                        <th style="width: 1%;">
                                            
                                        </th> 
                                    </thead>
                                    <tbody>   

                                        <tr v-for="item in data.pedidosRascunho">
                                            <td data-label="Cliente" v-on:click="$root.go('CadastrarPedidos', JSON.stringify({'_id': item.doc._id}))" style="position: relative;">
                                                {{item.doc.request.cliente.razaoSocial ? item.doc.request.cliente.razaoSocial : item.doc.request.cliente.nome}}

                                                <div class="button-right">
                                                    <a class=" button small red hidden-md hidden-xl hidden-lg" v-on:click.stop.prevent="delRascunho(item.doc._id)">
                                                        <i class="material-icons">close</i>
                                                    </a>
                                                </div>
                                            </td>                                                    
                                            <td data-label="Piloto" v-on:click="$root.go('CadastrarPedidos', JSON.stringify({'_id': item.doc._id}))">
                                                <u>{{item.doc.request.contratante.nome}}</u><br>
                                                <small><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.doc.request.auxiliar1}}</strong></small>
                                            </td>
                                            <td data-label="Combustível" v-on:click="$root.go('CadastrarPedidos', JSON.stringify({'_id': item.doc._id}))">
                                                {{item.doc.request.catalogo.nome}}<br>
                                                <small v-show="item.doc.request.quantidade && item.doc.request.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.doc.request.quantidade && item.doc.request.quantidade != 0 ? parseFloat(item.doc.request.quantidade.toString().replaceAll(',', '.')).toFixed(1).replaceAll('.', ',') + " litros" : ''}}</small>
                                            </td> 
                                            <td class="hidden-xs">
                                                <a class="dashboard-status-button red" v-on:click.stop.prevent="delRascunho(item.doc._id)">
                                                    <i class="material-icons" style="color: #fff;">close</i>
                                                </a>                                                
                                            </td>
                                            <td class="hidden-lg hidden-xl hidden-md" style="height: 0px; padding: 2px"></td>
                                        </tr>
                                                                                                                                                                                                  
                                    </tbody>
                                </table>    
                            </div>                                
                            
                            <div class="margin-top-20"></div>                         
                        </div>

                        <div class="col-xs-12" v-if="$root.user.tipo == 'contratante'">
                        
                            <div class="dashboard-box margin-top-0 cards" v-show="agendamentosProximos.length > 0">
                                <div class="content">
                                    <h5 class="block-title hidden-lg hidden-md hidden-xl hidden-sm">
                                        <i class="material-icons">event</i>
                                        Próximos agendamentos
                                    </h5>
                                    <ul class="dashboard-box-list" style="background: #f9f9f9;">
                                        
<!--                                         <li>
                                            <router-link :to="{'name': 'Pedidos'}" class="job-listing card" style="border-color: #7A7A7A; background: transparent;">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <h3 class="job-listing-title">
                                                                    <i class="material-icons">access_time</i>
                                                                    <b>
                                                                        22/07/2020 às 15:35
                                                                    </b>
                                                                </h3>
                                                                <span class="dashboard-status-button color-blue"><b>Agendado</b></span>

                                                                <i class="material-icons chevron-right">arrow_forward</i>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li> -->

                                        <li v-for="item in agendamentosProximos">
                                            <router-link :to="{'name': 'Pedidos', 'query': {'c': item.cod}}" class="job-listing card2" style="border-color: #7A7A7A; background: transparent;">
                                                <div class="job-listing-details">
                                                    <div class="job-listing-description">
                                                        <div class="row">
                                                            <div class="col-lg-12">
                                                                <h3 class="job-listing-title">
                                                                    <i class="material-icons">access_time</i>
                                                                    <b>
                                                                        {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                                                    </b>
                                                                </h3>
                                                                <span class="dashboard-status-button" v-bind:class="$root.config.pedidoStatus[item.status].class"><b>{{$root.config.pedidoStatus[item.status].text}}</b></span>
                                                                <span class="dashboard-status-button color-red" v-show="item.erro == 1"><b>{{item.statusObservacao}}</b></span>
                                                                <i class="material-icons chevron-right">arrow_forward</i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </router-link>
                                        </li> 
                                    </ul>
                                </div>
                            </div>  
                            <div class="hidden-xs margin-top-20"></div>                         
                        </div>
                        <div class="col-xs-12" v-if="$root.user.tipo == 'contratante'">
                            <div class="row">

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'PreAgendar'}" class="button-menu shadow">
                                        <i class="material-icons">event_available</i>
                                        Agendar novo abastecimento
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Pedidos'}" class="button-menu shadow">
                                        <i class="material-icons">local_gas_station</i>
                                        Ver todos os abastecimentos
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Pagamentos'}" class="button-menu shadow">
                                        <i class="material-icons">monetization_on</i>
                                        Dados para pagamento
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Premios'}" class="button-menu shadow">
                                        <i class="material-icons">card_giftcard</i>
                                        Prêmios
                                    </router-link>
                                </div>

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Contato'}" class="button-menu shadow">
                                        <i class="material-icons">chat</i>
                                        Fale conosco
                                    </router-link>
                                </div>            

                                <div class="col-xs-6 col-xl-3 col-md-6 col-lg-3">
                                    <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                        <i class="material-icons">account_circle</i>
                                        Minha conta
                                    </router-link>
                                </div>                                
                            </div>                            
                        </div>                            
                        <div class="col-lg-12 margin-bottom-18" v-if="$root.user.tipo == 'contratante'">
                            <div class="row">
                                <div class="col-xl-4 col-lg-5 col-xs-12 col-md-6">
                                    <div class="fun-facts-container border-green margin-top-0">
                                        <div class="fun-fact">
                                            <div class="fun-fact-text">
                                                <a >
                                                    <span>Pontos</span>
                                                    <h4>
                                                        {{$root.user.pontos}}
                                                    </h4>
                                                </a>
                                            </div>
                                            <div class="fun-fact-icon"><i class="material-icons">star</i></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-lg-12" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial' || $root.user.tipo == 'prestador'">

                            <div class="row" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'prestador' || $root.user.tipo == 'gerencial'">

                                <div class="col-xl-12" v-if="$root.user.tipo != 'gerencial'">
                                    <h4 class="margin-bottom-10">
                                        <i class="material-icons">redo</i>
                                        Atalhos
                                    </h4>
                                </div>

                                <!-- Dashboard Box -->
                                <div class="col-lg-12" v-if="$root.user.tipo != 'gerencial'">
                                    <router-link :to="{'name': 'CadastrarPedidos'}" class="button block-mobile small transparent margin-bottom-2">
                                        <i class="material-icons">local_gas_station</i>
                                        Cadastrar abastecimento
                                    </router-link>
                                    <div class="hidden-xl hidden-md hidden-lg margin-top-6"></div>
                                    <router-link :to="{'name': 'CadastrarVendas'}" class="button block-mobile small transparent margin-bottom-2" v-if="$root.user.tipo != 'gerencial'">
                                        <i class="material-icons">shopping_cart</i>
                                        Cadastrar venda - granel
                                    </router-link>
                                    <div class="hidden-xl hidden-md hidden-lg margin-top-6"></div>
                                    <br class="hidden-lg hidden-xs hidden-xl">
                                    <router-link v-if="$root.user.tipo == 'admin'" :to="{'name': 'CadastrarUsuariosContratante'}" class="button block-mobile small transparent margin-bottom-2">
                                        <i class="material-icons">airplanemode_active</i>
                                        Cadastrar piloto
                                    </router-link>
                                    <div class="hidden-xl hidden-md hidden-lg margin-top-6"></div>  
                                    <router-link v-if="$root.user.tipo == 'admin'" :to="{'name': 'CadastrarClientes'}" class="button block-mobile small transparent margin-bottom-2">
                                        <i class="material-icons">people</i>
                                        Cadastrar cliente
                                    </router-link>    
                                    <div class="margin-bottom-15"></div>
                                    <div class="hidden-xl hidden-md hidden-lg margin-bottom-25"></div>
                                </div>

                                <div class="col-xl-12 margin-bottom-20" v-if="$root.user.tipo == 'prestador'">                        

                                    <div class="metas margin-top-0 margin-bottom-10" v-for="(item, index) in Object.keys(metas.itens)">
                                        <h3 class="margin-bottom-0">
                                            <i class="material-icons">trending_up</i>
                                            <b>Metas</b>
                                        </h3>
                                        <div style="padding: 10px">
                                            <div class="row" style="border: 1px solid #ddd; background: #fff;">
                                                <div class="col-xl-4 col-md-6 col-lg-6 col-xs-12 tanque" v-for="(item2, index) in metas.itens[item]" style="text-align: center;">
                                                    <h4>
                                                        <b>{{item2.nome}}</b> (<b>{{item2.porcentagem}}%</b>)
                                                        <br>                        
                                                    </h4>
                                                    <!-- <img :src="$root.config.url + '/' + item2.imagem" style="width: 120px; margin-bottom: 15px"> -->
                                                    <div style="width: 100%; padding-left: 15px; padding-right: 15px;" class="">
                                                        <div class="progress margin-bottom-15">
                                                            <div class="progress-bar" :style="{'width': item2.porcentagem + '%'}" style="max-width: 100% !important;"></div>
                                                        </div>
                                                    </div>
                                                    <p>
                                                        Quantidade atual: <b>{{parseFloat(item2.atual).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b> (<b>{{item2.porcentagem}}%</b>)
                                                    </p>
                                                    <p>
                                                        Meta: <b>{{parseFloat(item2.total).toLocaleString("pt-br", {minimumFractionDigits: 1})}}L</b>
                                                    </p>
                                                    <p style="font-size: 16px; font-weight: 500; color: #333; margin-top: 10px;">
                                                        Recompensa: 
                                                        <span class="dashboard-status-button color-orange" style="margin-left: 5px;">
                                                            {{item2.recompensa}}
                                                        </span>                                                                                                                           
                                                    </p>                                                                                                                           
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- ===================================== -->

                                    <h4 class="margin-bottom-10">
                                        <i class="material-icons">warning</i> 
                                        <b>Aguardando confirmação</b>
                                    </h4>

                                    <div class="table-scroll" style="overflow-x: scroll;">

                                        <table class="table table-bordered table-bordered-default table-responsive">
                                            <thead>
                                                <th style="min-width: 30px; width: 30px;">
                                                    ID
                                                </th>
                                                <th style="min-width: 160px;">
                                                    Piloto
                                                </th>    
        <!--                                         <th style="min-width: 110px; width: 110px;">
                                                    Pref. aeronave
                                                </th>   -->      
                                                <th style="min-width: 100px; width: 100px;">
                                                    Combustível
                                                </th>                                              
                                                <th style="min-width: 130px; width: 130px;" v-if="$root.user.tipo == 'admin'">
                                                    Filial
                                                </th>                                                                                                                                             
                                                <th style="min-width: 155px; width: 155px;">
                                                    Agendado para
                                                </th>
                                                <th style="min-width: 80px; width: 80px;">
                                                    Ações
                                                </th>                                                                        
                                            </thead>
                                            <tbody>   
        <!--                                         <tr>
                                                    <td data-label="ID">
                                                        
                                                        1
                                                        </a>
                                                    </td>
                                                    <td data-label="Piloto">
                                                        
                                                        <u>Anderson Alves</u>
                                                        </a>
                                                    </td>
                                                    <td data-label="Combustível">
                                                        
                                                        JET-A1
                                                        </a>
                                                    </td> 
                                                    <td data-label="Litros">
                                                        
                                                        14
                                                        </a>
                                                    </td> 
                                                    <td data-label="Pref. aeronave">
                                                        
                                                        PT-ZKW
                                                        </a>
                                                    </td>    
                                                    <td data-label="Filial">
                                                        
                                                        Caçador SBCD                                                                                                         
                                                        </a>
                                                    </td>    
                                                    <td data-label="Agendado para">
                                                        
                                                        10/08/2020 08:52
                                                        </a>
                                                    </td>
                                                    <td data-label="Valor">
                                                        
                                                        R$ 568,67
                                                        </a>
                                                    </td>
                                                    <td data-label="Ações">
                                                        <a class="dashboard-status-button margin-bottom-5 color-green">Confirmar</a>
                                                    </td>
                                                </tr> -->

                                                <tr v-show="data.pendentes.itens.length == 0 && loaded">
                                                    <td colspan="9">
                                                        Nenhum resultado encontrado.
                                                    </td>
                                                </tr>

                                                <tr v-for="item in data.pendentes.itens">
                                                    <td data-label="ID">
                                                        {{item.id}}
                                                    </td>
                                                    <td data-label="Piloto">
                                                        <u>{{item.contratante.nome}}</u><br>
                                                        <small><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.auxiliar1}}</strong></small>
                                                        <br v-if="item.cliente">
                                                        <small v-if="item.cliente"><i class="material-icons">people</i> Cliente:    <strong style="font-weight: bold !important; color: #000;">{{item.cliente.razaoSocial ? item.cliente.razaoSocial : item.cliente.nome}}</strong></small>                                                         
                                                    </td>
                                                    <td data-label="Combustível">
                                                        {{item.catalogo.nome}}<br>
                                                        <small v-show="item.quantidade && item.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.quantidade && item.quantidade != 0 ? item.quantidade + " litros" : ''}}</small>
                                                    </td> 
        <!--                                             <td data-label="Pref. aeronave">
                                                        {{item.auxiliar1}}
                                                    </td>     -->
                                                    <td data-label="Filial" v-if="$root.user.tipo == 'admin'">
                                                        {{item.empresa.nome}}
                                                    </td>    
                                                    <td data-label="Agendado para">
                                                        {{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h
                                                    </td>
                                                    <td data-label="Ações">
                                                        <a class="dashboard-status-button margin-bottom-5 color-green click" v-on:click="confirmar(item.cod)">Confirmar</a>
                                                    </td>
                                                </tr>
                                                                                                                                                                                                          
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-xl-12">                        

                                    <h4 class="margin-bottom-10">
                                        <i class="material-icons">event</i> 
                                        <b>Agendamentos para hoje</b>
                                    </h4>

                                    <div class="table-scroll margin-bottom-20" style="overflow-x: scroll;">

                                        <table class="table table-bordered table-bordered-default table-responsive">
                                            <thead>
                                                <th style="min-width: 30px; width: 30px;">
                                                    ID
                                                </th>
                                                <th style="min-width: 160px;">
                                                    Piloto
                                                </th>
                                                <th style="min-width: 100px; width: 100px;">
                                                    Combustível
                                                </th>  
                                                <th style="min-width: 130px; width: 130px;" v-if="$root.user.tipo == 'admin'">
                                                    Filial
                                                </th>                                                                                                                                             
                                                <th style="min-width: 155px; width: 155px;">
                                                    Agendado para
                                                </th>
                                                <th style="min-width: 158px; width: 158px;">
                                                    Ações
                                                </th>                                                                        
                                            </thead>
                                            <tbody>   
                                              
<!--                                                 <tr>
                                                    <td data-label="ID">
                                                        <a >
                                                            1
                                                        </a>
                                                    </td>
                                                    <td data-label="Piloto">
                                                        <a >
                                                            <u>Anderson Alves</u><br>
                                                            <i class="material-icons">airplanemode_active</i>PT-ZKW
                                                        </a>
                                                    </td>
                                                    <td data-label="Combustível">
                                                        <a >
                                                            JET-A1
                                                        </a>
                                                    </td> 
                                                    <td data-label="Litros">
                                                        <a >
                                                            14
                                                        </a>
                                                    </td>  
                                                    <td data-label="Filial">
                                                        <a >
                                                            Caçador SBCD                                                                                                         
                                                        </a>
                                                    </td>    
                                                    <td data-label="Agendado para">
                                                        <a >
                                                            10/08/2020 08:52
                                                        </a>
                                                    </td>
                                                    <td data-label="Valor">
                                                        <a >
                                                            R$ 568,67
                                                        </a>
                                                    </td> 
                                                    <td data-label="Ações">
                                                        <a class="dashboard-status-button margin-bottom-5 color-green">Realizado</a>             
                                                        <a class="dashboard-status-button margin-bottom-5 color-red">Cancelar</a>          
                                                    </td>
                                                </tr>  -->

                                                <tr v-show="agendamentosProximos.length == 0 && loaded">
                                                    <td colspan="6">
                                                        Nenhum resultado encontrado.
                                                    </td>
                                                </tr>
                                                
                                                <tr v-for="item in data.agendamentos.itens" v-bind:class="{'error': item.erro == 1}">
                                                    <td data-label="ID">    
                                                        {{item.id}}
                                                        <span class="dashboard-status-button color-orange clearfix float-right hidden-lg hidden-xl hidden-md hidden-sm" v-show="item.erro == 1" style="margin-top: -12px; margin-right: 10px;">
                                                            <i class="material-icons" style="color: #fff !important;">warning</i>
                                                            <b>{{item.statusObservacao}}</b>
                                                        </span>                                                          
                                                    </td>
                                                    <td data-label="Piloto">
                                                        <u>{{item.contratante.nome}}</u><br>
                                                        <small><i class="material-icons">airplanemode_active</i> Pref. aeronave:    <strong style="font-weight: bold !important; color: #000;">{{item.auxiliar1}}</strong></small>
                                                        <br>
                                                        <span class="dashboard-status-button color-orange clearfix margin-top-5 hidden-xs" v-show="item.erro == 1">
                                                            <i class="material-icons" style="color: #fff !important;">warning</i>
                                                            <b>{{item.statusObservacao}}</b>
                                                        </span>                                                        
                                                    </td>
                                                    <td data-label="Combustível">
                                                        {{item.catalogo.nome}}<br>
                                                       <small v-show="item.quantidade && item.quantidade != 0"><i class="material-icons">local_gas_station</i>{{item.quantidade && item.quantidade != 0 ? item.quantidade + " litros" : ''}}</small>
                                                    </td> 
                                                    <td data-label="Filial" v-if="$root.user.tipo == 'admin'">
                                                        {{item.empresa.nome}}
                                                    </td>    
                                                    <td data-label="Agendado para">
                                                        <b>{{item.data | formatDate}} às {{item.horaInicio.substr(0,item.horaInicio.length -3)}}h</b>
                                                    </td>
                                                    <td data-label="Ações">
                                                        <router-link :to="{'name': 'EditarPedidos', 'query': {'c': item.cod}}" class="dashboard-status-button margin-bottom-5 color-green click">Concluir</router-link>             
                                                        <a class="dashboard-status-button margin-bottom-5 color-red click" v-on:click="cancelar(item.cod)">Cancelar</a>             
                                                    </td>
                                                </tr>  

                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-xs-12 hidden-lg hidden-xl">
                                    <div class="row">
                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Agendamentos'}" class="button-menu shadow">
                                                <i class="material-icons">event_available</i>
                                                Agendamentos
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Pedidos'}" class="button-menu shadow">
                                                <i class="material-icons">local_gas_station</i>
                                                Abastecimentos
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo != 'gerencial'">
                                            <router-link :to="{'name': 'Vendas'}" class="button-menu shadow">
                                                <i class="material-icons">shopping_cart</i>
                                                Vendas - granel
                                            </router-link>
                                        </div>                                        

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                            <router-link :to="{'name': 'UsuariosContratante'}" class="button-menu shadow">
                                                <i class="material-icons">airplanemode_active</i>
                                                Pilotos
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Clientes'}" class="button-menu shadow">
                                                <i class="material-icons">people</i>
                                                Clientes
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Pagamentos'}" class="button-menu shadow">
                                                <i class="material-icons">monetization_on</i>
                                                Dados para pagamento
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo != 'gerencial'">
                                            <router-link :to="{'name': 'PrecosEspeciais'}" class="button-menu shadow">
                                                <i class="material-icons">attach_money</i>
                                                Preços especiais
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Metas'}" class="button-menu shadow">
                                                <i class="material-icons">trending_up</i>
                                                Metas
                                            </router-link>
                                        </div>                                        

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Estoque'}" class="button-menu shadow">
                                                <i class="material-icons">assessment</i>
                                                Estoque
                                            </router-link>
                                        </div>                                        

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Premios'}" class="button-menu shadow">
                                                <i class="material-icons">card_giftcard</i>
                                                Prêmios
                                            </router-link>
                                        </div>

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                            <router-link :to="{'name': 'Logs'}" class="button-menu shadow">
                                                <i class="material-icons">watch_later</i>
                                                Histórico
                                            </router-link>
                                        </div>  

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo == 'admin'">
                                            <router-link :to="{'name': 'Avaliacoes'}" class="button-menu shadow">
                                                <i class="material-icons">star</i>
                                                Avaliações
                                            </router-link>
                                        </div>                                             

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo == 'admin'">
                                            <router-link :to="{'name': 'Chat'}" class="button-menu shadow">
                                                <i class="material-icons">message</i>
                                                Chat
                                            </router-link>
                                        </div>                                             

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo == 'admin'">
                                            <router-link :to="{'name': 'Alertas'}" class="button-menu shadow">
                                                <i class="material-icons">notifications</i>
                                                Alertas
                                            </router-link>
                                        </div>   

                                        <div class="col-xs-6 col-xl-3 col-md-4" v-if="$root.user.tipo == 'admin'">
                                            <router-link :to="{'name': 'Notificacoes'}" class="button-menu shadow">
                                                <i class="material-icons">email</i>
                                                Lembretes
                                            </router-link>
                                        </div>                                             

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Relatorios'}" class="button-menu shadow">
                                                <i class="material-icons">format_list_numbered</i>
                                                Relatórios
                                            </router-link>
                                        </div>                                 

                                        <div class="col-xs-6 col-xl-3 col-md-4">
                                            <router-link :to="{'name': 'Arquivos'}" class="button-menu shadow">
                                                <i class="material-icons">insert_drive_file</i>
                                                Documentos
                                            </router-link>
                                        </div>                                                                                                                        

                                        <div class="col-xs-6 col-xl-3 col-md-4 col-lg-3 hidden-md">
                                            <router-link :to="{'name': 'Conta'}" class="button-menu shadow">
                                                <i class="material-icons">account_circle</i>
                                                Minha conta
                                            </router-link>
                                        </div>  

                                    </div>
                                </div>

                            </div>

                            <div class="fun-facts-container row margin-top-0" v-if="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'">
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Clientes</span>
                                                <h4>
                                                    {{data.metricas.clientes}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">people</i></div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Pilotos</span>
                                                <h4>
                                                    {{data.metricas.usuarios}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">airplanemode_active</i></div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Pré-agendamentos</span>
                                                <h4>
                                                    {{data.metricas.preAgendamentos}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">warning</i></div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Agendamentos</span>
                                                <h4>
                                                    {{data.metricas.agendamentos}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">event_available</i></div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Abastecimentos</span>
                                                <h4>
                                                    {{data.metricas.abastecimentos}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">local_gas_station</i></div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Filiais</span>
                                                <h4>
                                                    {{data.metricas.empresas}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">store</i></div>
                                    </div>
                                </div>
                                <div class="col-xl-4 col-lg-6 col-xs-12 col-md-6 margin-bottom-18">
                                    <div class="fun-fact">
                                        <div class="fun-fact-text">
                                            <a >
                                                <span>Prêmios</span>
                                                <h4>
                                                    {{data.metricas.premios}}
                                                </h4>
                                            </a>
                                        </div>
                                        <div class="fun-fact-icon"><i class="material-icons">card_giftcard</i></div>
                                    </div>
                                </div>                                                                                               

                            </div>
                        </div>
                        
                    </div>
                    <!-- Row / End -->
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Dashboard',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },     
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },        
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "metas":     {
                "itens":        []
            },
            "data":                 {
                "agendamentosProximos": [],
                "pedidosRascunho":      [],
                "notificacoes":     {
                    "itens":        []
                },
                "agendamentos":     {
                    "itens":        []
                },
                "pendentes":        {
                    "itens":        []
                },                
                "metricas":         {
                    "usuarios":         null,
                    "preAgendamentos":  null,
                    "agendamentos":     null,
                    "abastecimentos":   null,
                    "empresas":         null,
                    "premios":          null
                }
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             "agendamento",
                "filtro":           "pendentes"
            }              
        }
    },
    computed: {
        agendamentosProximos: function () {
            function compare(a, b) {
                if ((new Date(a.data + " " + a.horaInicio)).getTime() < (new Date(b.data + " " + b.horaInicio)).getTime())
                    return -1;
                if ((new Date(a.data + " " + a.horaInicio)).getTime() > (new Date(b.data + " " + b.horaInicio)).getTime())
                    return 1;
                return 0;
            }
            console.log("verifica")
            return this.data.agendamentos.itens.sort(compare);
        }
    },    
    methods: {
        getMetas: function() {
            var self        = this;
            console.log("getMetas()");
            self.metas.itens = [];
            self.loaded     = false;
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "prestador") {
                    return resolve(true);
                };

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "empresaCod":   self.$root.user.empresaCod,
                        "mes":          (new Date().getMonth()+1),
                        "ano":          (new Date().getFullYear())
                    }
                };

                axios.get("api/metas.php", form)
                .then(response => {
                    
                    console.log("getMetas() response", response);

                    var keys = Object.keys(response.data.result.itens);
                    console.log("keys", keys);
                    keys.forEach(function(key) {
                        console.log("key>", key);
                        response.data.result.itens[key].forEach(function(item, index) {
                            var porcentagem = (parseFloat(item.atual) / parseFloat(item.total)) * 100;
                            response.data.result.itens[key][index]["porcentagem"] = porcentagem > 0 ? (porcentagem).toFixed(1) : 0;
                        });
                    });

                    self.metas.itens     = response.data.result.itens; 
                    self.loaded         = true;
                    loading.hide();
                    resolve(response.data.result);
                    // if (self.tab == "visualizar") self.loadChart();
                    self.$root.scrollTop();
  
                })
                .catch(error => {
                    console.log("getMetas() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },        
        getMetricas: function() {
            var self        = this;
            console.log("getMetricas()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo != "admin" && self.$root.user.tipo != "gerencial") {
                    return resolve(true);
                };

                axios.get("api/metricas.php", {params: self.form, db: "metricas"})
                .then(response => {
                    
                    console.log("getMetricas() response", response);    
                    self.data.metricas               = response.data.result; 
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getMetricas() error", error);                    
                    // loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getPedidosPendentes: function() {
            var self        = this;
            console.log("getPedidosPendentes()");
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "admin" || self.$root.user.tipo == "contratante" || self.$root.user.tipo == "gerencial") {
                    return resolve(true);
                }

                var form = {
                    "db":               "pedidosPendentes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "agendamento",
                        "filtro":       "pendentes"
                    }
                };                

                axios.get("api/pedidos.php", form)
                .then(response => {
                    
                    console.log("getPedidosPendentes() response", response);
                    response.data.result.itens  = response.data.result.itens.filter(function(item) {
                        if (item.status == 0) return item;
                    });
                    self.data.pendentes         = response.data.result; 
                    self.loaded                 = true;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getPedidosPendentes() error", error);                    
                    // loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getPedidos: function() {
            var self        = this;
            console.log("getPedidos()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "admin" || self.$root.user.tipo == "prestador" || self.$root.user.tipo == "gerencial") {
                    self.form.filtro    = "hoje";
                }

                axios.get("api/pedidos.php", {params: self.form, db: "pedidosDashboard"})
                .then(response => {
                    
                    console.log("getPedidos() response", response);
                    self.data.agendamentos      = response.data.result; 
                    self.loaded                 = true;
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getPedidos() error", error.response);                    
                    // loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getNotificacoes: function() {
            var self        = this;
            console.log("getNotificacoes()", self.form);
            // loading.show();
            return new Promise(function(resolve, reject) {

                if (self.$root.user.tipo == "contratante") {
                    resolve(null);
                    return false;
                }
                var form = {
                    "db":               "notificacoes",
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "dashboard"
                    }
                };       
                axios.get("api/notificacoes.php", form)
                .then(response => {
                    
                    console.log("getNotificacoes() response", response);
                    self.data.notificacoes      = response.data.result; 
                    // loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getNotificacoes() error", error.response);                    
                    // loading.hide();
                    reject(error);
                    // alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        confirmar: function(cod) {
            console.log("confirmar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja confirmar?", function() {
                
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "confirmar"
                };                

                self.loading.confirmar   = true;
                loading.show();
                
                axios.put("api/agendamento.php", form)
                .then(response => {
                    console.log("confirmar() response", response)
                    self.loading.confirmar    = false;
                    alert(response.data.message);
                    
                    self.init();                  

                })
                .catch(error => {
                    console.log("confirmar() error", error)
                    loading.hide();
                    self.loading.confirmar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        cancelar: function(cod) {
            console.log("cancelar()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja cancelar?", function() {
                var texto               = prompt("Qual o motivo do cancelamento?");
                if (!texto)             return false; 
                self.loading.cancelar   = true;
             
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "pedidoCod":    cod,
                    "acao":         "cancelar",
                    "texto":        texto
                };                

                loading.show();
                
                axios.put("api/agendamento.php", form)
                .then(response => {
                    console.log("cancelar() response", response)
                    self.loading.cancelar    = false;
                    self.init();
                    alert(response.data.message);
                })
                .catch(error => {
                    console.log("cancelar() error", error)
                    loading.hide();
                    self.loading.cancelar    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        confirmarNotificacoes: function(cod) {
            console.log("confirmarNotificacoes()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja confirmar?", function() {
                
                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "notificacaoCod":cod,
                    "acao":         "confirmar"
                };                

                loading.show();
                
                axios.put("api/notificacoes.php", form)
                .then(response => {
                    console.log("confirmarNotificacoes() response", response)
                    // alert(response.data.message);
                    self.getNotificacoes().finally(function() {
                        loading.hide();
                    });
                })
                .catch(error => {
                    console.log("confirmarNotificacoes() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        getPedidosRascunho: function() {
            var self        = this;
            return new Promise(function(resolve, reject) {            
                console.log("DB", self.$root.db["pedidosRascunho"])

                self.$root.db["pedidosRascunho"].query(function(doc) {
                    emit(doc);
                }, {include_docs : true}).then(function (result) {
                    console.log("pedidosRascunho find()", "ok:", result);
                    self.data.pedidosRascunho = result.rows;
                    self.$forceUpdate();
                    resolve(result);
                }).catch(function (err) {
                    console.log("pedidosRascunho find()", "erro:", err);
                    resolve(err);
                }); 

            });  
        },
        delRascunho: function(_id) {
            console.log("delRascunho", _id)
            var self = this;
            confirm("Você tem certeza que deseja remover este item?", function() {
                self.$root.db["pedidosRascunho"].get(_id).then(function (doc) {
                    return self.$root.db["pedidosRascunho"].remove(doc._id, doc._rev);
                }).then(function(result) {
                    console.log("pedidosRascunho delete ok", result);
                }).catch(function(error) {
                    console.log("pedidosRascunho delete error", error);
                }).finally(function() {
                    self.getPedidosRascunho();                   
                });                
            });         
        },
        init: function() {
            console.log("init()");
            var self = this;

            loading.show();
            Promise.all([
                self.getMetricas(),
                self.getPedidosPendentes(),
                self.getPedidos(),
                self.getNotificacoes(),
                self.getPedidosRascunho(),
                self.getMetas(),
            ]).then(function() {
                loading.hide();
            }).catch(function(error) {
                loading.hide();
            });               
        }
    },
    created: function() {
        var self = this;
            
        window.__resume = self.init;
        self.init();
        if (self.$root.user.tipo == "contratante") {
            self.$root.getUser();
        }

        // if (self.$root.user.tipo != "contratante") {
        if (self.$root.user.tipo != "contratante" && window.cordova) {
            self.$root.syncInfosDB();
        }

    },
    mounted: function() {
        // setTimeout(function() {
        //     $(".dashboard-content-inner")[0].scrollTop = 0;
        // }, 100);
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button-right {
        position: absolute;
        top: 0px;
        right: 7px;
        
    }
    .button-right .button {
        padding: 2px;
        height: 20px;
        line-height: 18px;
        padding: 0px 0px 0px 2px;    
    }
    .button-right i {
        color: #fff;
    }


    .metas .tanque {
        border: 1px solid #ddd;
        text-align: center;
        padding: 2%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #fff;
    }
    .metas .tanque h1 {
        position: absolute;
        /*display: block;*/
        /*margin: 0 auto;*/
        text-align: center;
    }
    .metas .tanque h4 {
        text-align: center;
        font-size: 1.1em;
        margin-bottom: 15px;
    }
    .metas .tanque-nivel {
        width: 100%;
        background: #ddd;
        height: 10%;
        position: relative;
        bottom: 0px;
        z-index: -1;
    }
    .metas .tanque p {
        margin-bottom: 0px;
    }
    .metas .tanque p b {
        color: #333;
    }

    .metas .tanque-area {
        display: flex;
        align-items: flex-end;
        align-content: center;
        border-bottom-right-radius: 100%;
        border-bottom-left-radius: 100%;
        /*text-align: center;*/
        width: 10em;
        height: 10em;
        border-radius: 50%;
        border: 2px solid #666;
    }

    .metas .dashboard-status-button.color-green {
        /*display: block; */
        /*background: #F89012 !important;*/
        margin-top: 5px; 
        color: #fff !important;
        width: auto; 
        padding: 2px 8px;
        text-align: center;
    }

    .metas .dashboard-status-button.color-green i {
        font-size: 16px;
        color: #fff;
    }

    .metas .progress {
        width: 100%;
        background: #ddd;
        height: 25px;
    }

    .metas .progress-bar {
        /*width: 100%;*/
        background: #4cd964;
        height: 25px;
    }    
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue